// extracted by mini-css-extract-plugin
module.exports = {"image":"_2lPLFN","backgroundImg":"_1fsCO3","link":"_3b0DpZ"};